import { action, makeObservable, observable } from 'mobx';
import { IExecutionJobSummary as IJobExecutionSummary } from '../../dto/device-dto';
import { IDeviceDetailsConstructorOptions } from './device-detail-entry-store';
import { DevicesStore } from 'store/devices-store';

interface IJobStatusDetailsProps {
    [key: string]: string;
}

export interface IDisplayJobExecutionSummary extends IJobExecutionSummary {
    key: string;
    jobName: string;
    displayLastUpdatedAt?: string;
    data?: IJobStatusDetailsProps;
}

export class ManageDeviceJobStore {
    private _devicesStore: DevicesStore;
    private uid: string;
    private accountId: number;

    constructor(options: IDeviceDetailsConstructorOptions) {
        this._devicesStore = options.devicesStore;
        this.uid = options.uid;
        this.accountId = options.accountId;
        makeObservable(this);
    }

    public async getDetailsByExecution(record: IDisplayJobExecutionSummary): Promise<any> {
        const jobInfo = await this._devicesStore.getRemoteCommandExecutionDetailsByExecutionId(this.accountId, record.jobId, {
            deviceName: this.uid,
            executionNumber: record.executionNumber,
        });
        return jobInfo?.statusDetails?.detailsMap || {};
    }

    public async rerunExecutionCommand(job: IDisplayJobExecutionSummary) {
        await this._devicesStore.rerunExecutionCommand(this.accountId, job.jobId, { deviceName: this.uid });
    }

    public async cancelExecutionCommand(job: IDisplayJobExecutionSummary) {
        await this._devicesStore.cancelRemoteCommandByExecutionId(this.accountId, job.jobId, { targetDeviceNames: [this.uid] });
    }

    public async loadJobs(limit: number, nextToken?: string) {
        const result = await this._devicesStore.getDeviceJobs(this.accountId, this.uid, { limit: limit, nextToken });
        return result;
    }
}
